import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import _ from 'lodash';
import AddUpdateBrochure from '..';
import { addToBrochure } from '../../../../store/slices/brochure';
import { TravelTypes } from '../../../../constants';

const TourAddUpdateToBrochure = ({
  tripId, tourItinerary, rate, className,
}) => {
  const { track } = useAnalytics();
  const { brochure } = useSelector((state) => state.brochure);
  const {
    staterooms,
  } = useSelector((store) => store.tripSearch.searchObj);
  const dispatch = useDispatch();
  const [isSelected, setIsSelected] = useState(false);
  const findTourItineraryByKey = (tripSegments, tourKey) => _.find(tripSegments,
    (ts) => ts.itinerary.uniqueKey === tourKey);
  const findTourRate = (rates, rateCode) => _.find(rates,
    (r) => r.code === rateCode);
  const findTourItineraries = (trip) => _.filter(trip.tripSegments,
    (ts) => ts.itinerary.mode === TravelTypes.tour);

  const handleAddToBrochureClick = () => {
    let updatedTrip = { tripSegments: [] };
    if (brochure && brochure.trips && brochure.trips[tripId]) {
      // Clone brochure, we can not update brochure value
      updatedTrip = JSON.parse(JSON.stringify(brochure.trips[tripId]));
    }

    const tripSegment = findTourItineraryByKey(updatedTrip.tripSegments,
      tourItinerary.uniqueKey);
    if (!tripSegment) {
      updatedTrip.tripSegments.push({
        itinerary: {
          ...tourItinerary,
          rates: [{ ...rate }],
        },
      });
    } else {
      const matchedRate = findTourRate(tripSegment.itinerary.rates, rate.code);
      if (matchedRate) {
        _.remove(tripSegment.itinerary.rates, (r) => r.code === rate.code);
      } else {
        tripSegment.itinerary.rates.push(rate);
      }
      if (!tripSegment.itinerary.rates
          || tripSegment.itinerary.rates.length === 0) {
        _.remove(updatedTrip.tripSegments,
          (ts) => ts.itinerary.uniqueKey === tripSegment.itinerary.uniqueKey);
      }
    }
    dispatch(addToBrochure({
      tripId,
      updatedTrip,
      staterooms,
    }));
    track('TourAddUpdateToBrochure.handleAddToBrochureClick');
  };
  useEffect(() => {
    setIsSelected(false);
    // eslint-disable-next-line no-useless-return
    if (!brochure || !brochure.trips || !brochure.trips[tripId]) return;
    // Check if flight itinerary is in brochure
    const tripSegments = findTourItineraries(brochure.trips[tripId]);
    if (tripSegments && tripSegments.length) {
      const matchedTourTripSeg = findTourItineraryByKey(tripSegments, tourItinerary.uniqueKey);
      if (matchedTourTripSeg != null) {
        const matchedRate = findTourRate(matchedTourTripSeg.itinerary.rates, rate.code);
        if (matchedRate) {
          setIsSelected(true);
        }
      }
    }
  }, [brochure, rate, tourItinerary, tripId]);

  return (
    <AddUpdateBrochure
      handleAddToBrochureClick={handleAddToBrochureClick}
      className={className}
      isSelected={isSelected}
    />
  );
};

TourAddUpdateToBrochure.propTypes = {
  className: PropTypes.string,
  tripId: PropTypes.string.isRequired,
  tourItinerary: PropTypes.shape().isRequired,
  rate: PropTypes.shape().isRequired,
};
TourAddUpdateToBrochure.defaultProps = {
  className: '',
};

export default TourAddUpdateToBrochure;
